export const CHALLENGE_HOST_CLASS = 'fastly-challenge';
